import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosHttp from "services/axiosHttp";

//CREATE ACTION
export const supervisorTransportRequestCreate = createAsyncThunk("supervisorTransportRequestCreate", async ({ data }, { rejectWithValue }) => {
    try {
        console.log("Supervisor Transport data", data);
        const response = await axiosHttp.post(`requests/supervisor/transport`, data);
        return response.data;

    } catch (err) {
        if (!err.response) {
            throw err;
        }
        return rejectWithValue(err.response.data);
    }
});

const supervisorTransportRequestCreateSlice = createSlice({
    name: "supervisorTransportRequestCreateSlice",
    initialState: {
        isLoading: false,
        isError: false,
        error: null,
        data: null,
    },

    reducers: {
        resetSupervisorTransportCreateState: (state) => {
            state.isLoading = false;
            state.isError = false;
            state.error = null;
            state.data = null;
        },
    },

    extraReducers: (builder) => {
        builder.addCase(supervisorTransportRequestCreate.pending, (state) => {
            state.isLoading = true;
            state.isError = false;
        });

        builder.addCase(supervisorTransportRequestCreate.fulfilled, (state, action) => {
            state.isLoading = false;
            state.data = action.payload;
            
            // Check if all requests failed
            const hasFailed = action.payload?.data?.failed?.length > 0;
            const hasCreated = action.payload?.data?.created?.length > 0;
            
            if (hasFailed && !hasCreated) {
                // All failed
                state.isError = true;
            } else {
                // All success
                state.isError = false;
            }
        });

        builder.addCase(supervisorTransportRequestCreate.rejected, (state, action) => {
            state.isLoading = false;
            state.isError = true;
            state.error = action.payload;
        });
    },
});

export const { resetSupervisorTransportCreateState } = supervisorTransportRequestCreateSlice.actions;
export default supervisorTransportRequestCreateSlice.reducer;